import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import client from "../lib/api";

/**
 * ReturnRitual.
 *
 * A small warm greeting at the top of the pledge card that names
 * a real, cited change since the person's last visit. Graceful
 * absence: if nothing has moved yet, we show a warm welcome with
 * no invented cite. Deterministic on the server.
 *
 * Sources the ritual can cite from (server-side):
 *   * sparkline_delta between the two most recent reads
 *   * a milestone_closed on this pledge
 *   * a safely-surfaced ledger prediction (allowed classes only)
 *
 * Never a tracker. Never a distress signal. Never a raw state.
 */
export function ReturnRitual({ pledgeId }) {
  const [ritual, setRitual] = useState(null);

  useEffect(() => {
    let alive = true;
    if (!pledgeId) return () => { alive = false; };
    client.get(`/accountability/pledge/${pledgeId}/return-ritual`)
      .then((r) => { if (alive) setRitual(r.data); })
      .catch(() => { if (alive) setRitual(null); });
    return () => { alive = false; };
  }, [pledgeId]);

  if (!ritual) return null;

  return (
    <div className="k-warm-card p-3 mb-4" data-testid="return-ritual">
      <div className="flex items-start gap-2">
        <Sparkles size={14} className="mt-1" />
        <div className="flex-1">
          <div className="klareet-serif text-sm" style={{ lineHeight: 1.5 }} data-testid="return-ritual-message">
            {ritual.message}
          </div>
          {ritual.cited_change?.source && (
            <div className="k-quiet !text-xs mt-1" data-testid={`return-ritual-source-${ritual.cited_change.source}`}>
              cited from your {ritual.cited_change.source.replace(/_/g, " ")}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
